import { render, staticRenderFns } from "./FundacaoPalmares.vue?vue&type=template&id=30d58bd2&lang=pug"
import script from "./FundacaoPalmares.vue?vue&type=script&lang=js"
export * from "./FundacaoPalmares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports